/**
 * Integration-settings context type. Set via the shared
 * useContextDrawer().setContext() — there is only one context manager for the
 * entire drawer. Selecting an integration on the Integrations page opens
 * IntegrationsContextPanel in the docked right column (mirrors how a canvas
 * node opens SalesPlayContextPanel).
 */

import type { InjectionKey } from 'vue'

export const INTEGRATION_CONTEXT_TYPE = 'integration' as const

export interface IntegrationContext {
  type: typeof INTEGRATION_CONTEXT_TYPE
  /** Registry plugin id: 'salesforce' | 'hubspot' | 'pipedrive' | 'slack' | 'twilio' | … */
  provider: string
}

/**
 * Provided (true) by IntegrationsContextPanel so the integration drawer bodies it hosts render
 * "embedded" — without their own SlideOver overlay / header / close (the docked panel owns the shell).
 * Injected by IntegrationsModal; defaults to false for any standalone (overlay) caller.
 */
export const INTEGRATION_PANEL_EMBEDDED: InjectionKey<boolean> = Symbol('integrationPanelEmbedded')

/** CRM providers render the rich tabbed IntegrationDrawer; everything else uses its registry modal. */
export const CRM_PROVIDERS = ['salesforce', 'hubspot', 'pipedrive'] as const
export function isCrmProvider(provider: string): boolean {
  return (CRM_PROVIDERS as readonly string[]).includes(provider)
}
